module.exports = __webpack_public_path__ + "img/voice-waveform.06a24837.svg";